<template>
    <v-navigation-drawer :rail="miniVariant" rail-width="75" location="right" mobile-breakpoint="lg" style="background: linear-gradient(0deg, rgba(13,59,102,1) 50%, rgba(11,84,152,1) 100%);" :width="300" :model-value="$vuetify.display.lgAndUp || drawer"  @update:modelValue="(value) => drawer = value">
        <div class="d-flex flex-column h-screen">
            <a :href="$system.systemSettings.logo_link" class="my-3 text-center" target="_blank">
                <v-img v-if="miniVariant && $system.systemSettings.small_logo_name" :src="$system.systemSettings.small_logo_name" class="mx-auto rounded-sm w-100 mx-3" :height="45"></v-img>
                <v-img v-else-if="miniVariant" src="@/assets/img/helpical-logo-sidebar-small.png" class="mx-auto rounded-sm w-100 mx-3" :height="45"></v-img>
                <v-img v-else-if="$system.systemSettings.logo_name" :src="$system.systemSettings.logo_name" class="mx-auto rounded-sm w-100 mx-3" :height="56"></v-img>
                <v-img v-else src="@/assets/img/logo-white.png" class="mx-auto rounded-sm w-100 mx-3" :height="56"></v-img>
            </a>
            <div class="px-2 w-100 flex-grow-1 d-flex flex-column justify-center" v-if="!miniVariant">
                <v-list
                    mandatory
                    density="default"
                    v-model:opened="openedMenu"
                    v-model:selected="selectedMenu"
                    @update:selected="$router.push({ path: selectedMenu[0] })"
                    class="w-100"
                    selected-class="bg-secondary"
                    open-strategy="single"
                >
                    <template v-for="item in items.filter(x => x.children.some(y => y.permission))">
                        <v-list-item class="text-white" rounded v-if="item.children.filter(x => x.permission).length === 1" :value="item.children.find(x => x.permission).to">
                            <template v-slot:prepend>
                                <i class="icon icon-lg me-5" :class="item.icon">
                                    <span v-for="i in item.iconPath" :class="`path${i}`" class="icon"></span>
                                </i>
                            </template>
                            <v-list-item-title class="text-meta font-weight-medium">{{ item.title }}</v-list-item-title>
                        </v-list-item>
                        <v-list-group :value="item.title" v-else>
                            <template v-slot:activator="{ props }">
                                <v-list-item v-bind="props" class="text-white" rounded>
                                    <template v-slot:prepend>
                                        <i class="icon icon-lg me-5" :class="item.icon">
                                            <span v-for="i in item.iconPath" :class="`path${i}`" class="icon"></span>
                                        </i>
                                    </template>
                                    <v-list-item-title class="text-meta font-weight-medium">{{ item.title }}</v-list-item-title>
                                </v-list-item>
                            </template>
                            <v-list-item v-for="inner in item.children.filter(x => x.permission)" :value="inner.to">
                                <v-list-item-title class="text-meta text-white">{{ inner.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list-group>
                    </template>
                </v-list>
            </div>
            <div class="px-2 w-100 flex-grow-1" v-if="miniVariant">
                <div v-for="item in items.filter(x => x.children.some(y => y.permission))" class="my-4">
                    <v-btn v-if="item.children.filter(x => x.permission).length === 1" v-tooltip="item.title" :model-value="item.children.find(x => x.permission).to" variant="text" @click="$router.push({ path: item.children.find(x => x.permission).to })">
                        <i class="icon icon-lg" :class="item.icon"><span v-for="i in item.iconPath" :class="`path${i}`" class="icon"></span></i>
                    </v-btn>
                    <v-menu close-on-content-click location="left" v-else>
                        <template v-slot:activator="{ props }">
                            <div v-bind="props">
                                <v-btn v-tooltip="item.title" variant="text">
                                    <i class="icon icon-lg" :class="item.icon"><span v-for="i in item.iconPath" :class="`path${i}`" class="icon"></span></i>
                                </v-btn>
                            </div>
                        </template>
                        <v-list>
                            <v-list-item v-for="inner in item.children.filter(x => x.permission)" @click="$router.push({ path: inner.to })">
                                <v-list-item-title class="text-meta">{{ inner.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>
            <div class="px-2 py-3 w-100" style="background-color:#0A2D4E;">
                <div class="d-flex justify-center ga-3">
                    <a target="_blank" href="https://helpical.com">
                        <v-img src="@/assets/img/helpical-logo-sidebar-small.png" class="mx-auto" :aspect-ratio="0.91666" width="36"></v-img>
                    </a>
                    <div v-if="!miniVariant">
                        <a target="_blank" href="https://helpical.com" class="d-block text-small font-weight-medium text-white text-decoration-none">نرم‌افزار هلپ دسک و تیکتینگ هلپیکال</a>
                        <a target="_blank" href="https://helpical.com/changelog" class="d-block text-small text-white text-decoration-none">نسخه {{ $system.systemSettings.version }}</a>
                    </div>
                </div>
                <div class="mt-1 text-center">
                    <span v-if="!miniVariant" class="text-small rounded py-1 user-select-none font-weight-medium text-white px-5" style="background-color:#0B5498">{{ $moment(new Date).format('dddd jD jMMMM jYYYY') }}</span>
                    <span v-else class="text-small rounded py-1 user-select-none font-weight-medium text-white px-1" style="background-color:#0B5498">{{ $moment(new Date).format('jYYYY/jMM/jDD')}}</span>
                </div>
            </div>
        </div>
    </v-navigation-drawer>
    <v-app-bar color="white" density="default" flat class="px-4">
        <v-btn @click="drawer = !drawer" class="d-block d-lg-none mx-2" color="grey-darken-1" variant="text" icon="menu"></v-btn>
        <v-btn @click="miniVariant = !miniVariant" class="d-none mx-2 d-lg-block" color="grey-darken-1" variant="text" :icon="miniVariant ? 'icon-shrink-sidebar' : 'icon-expand-sidebar'"></v-btn>
        <v-btn @click="toggleFullscreen" color="grey-darken-1" variant="text" class="d-none mx-2 d-lg-block" icon="icon-Full-Screen"></v-btn>
        <div class="bg-grey-lighten-4 text-grey-darken-2 rounded-lg py-2 px-4 text-small ms-2 user-select-none d-none d-md-block" v-if="$auth.user.full_admin && +$moment($system.license.expired_at, 'YYYY/MM/DD').diff($moment(new Date()), 'days') <= 7">
            از اعتبار لایسنس شما {{ $moment($system.license.expired_at).fromNow().replace('در ', '') }} باقی مانده است
            <span class="mx-2 text-meta">|</span> <a href="https://panel.helpical.ir" rel="nofollow" target="_blank" class="font-weight-medium text-grey-darken-2 text-decoration-none">تمدید لایسنس</a>
        </div>
        <div class="text-error rounded-lg py-2 px-4 text-small ms-2 user-select-none d-none d-md-block" style="background-color: #bf00251a" v-if="!$auth.user.employee && +$moment($auth.user.expire_date).diff($moment(new Date()), 'minutes') <= 0">
            حساب کاربری شما محدود شده است
        </div>
        <div class="text-error rounded-lg py-2 px-4 text-small ms-2 user-select-none d-none d-md-block" style="background-color: #bf00251a" v-else-if="!$auth.user.employee && +$moment($auth.user.expire_date).diff($moment(new Date()), 'days') <= 7">
            حساب کاربری شما تا {{ $moment($auth.user.expire_date).fromNow().replace('در ', '') }} دیگر محدود خواهد شد
        </div>
        <v-spacer />
        <div class="me-3 cursor-pointer" v-if="$refs.voipDialog && $refs.voipDialog.minimize" @click="$refs.voipDialog.minimize = false; $refs.voipDialog.dialog = true">
            <v-img :src="$refs.voipDialog.userProfileImg" width="40" height="40" class="rounded-circle voipDialog-img">
                <div class="voipDialog-img-icon bg-green">
                    <v-icon color="white" size="18">call</v-icon>
                    <div class="position-relative voipDialog-img-icon-items"><span /><span /></div>
                </div>
            </v-img>
        </div>
        <v-btn class="mx-3 px-3 d-none d-sm-block" color="grey-lighten-1" variant="outlined" rounded="pill" @click="openBasicSettings" v-if="$auth.user.full_admin && basicSettingsPercent !== 100">
            <v-progress-circular color="secondary" size="20" class="me-2" :model-value="basicSettingsPercent"></v-progress-circular>
            <span class="font-weight-medium text-primary">راه اندازی سامانه</span>
        </v-btn>
        <v-divider vertical inset></v-divider>
        <v-btn v-if="$auth.user.employee" icon="icon-date" variant="text" color="grey-darken-1" class="mx-2" @click="$refs.calendar.dialog = true"></v-btn>
        <v-menu transition="slide-y-transition" :width="250" content-class="bg-white elevation-1">
            <template v-slot:activator="{ props }">
                <v-btn icon="icon-info" variant="text" color="grey-darken-1" class="mx-2" v-bind="props" v-if="$auth.user.full_admin"></v-btn>
            </template>
            <system-information />
        </v-menu>
        <v-menu transition="slide-y-transition" :width="350" content-class="bg-white elevation-1">
            <template v-slot:activator="{ props }">
                <v-btn variant="text" icon color="grey-darken-1" @click="userNotificationBadge = false" class="mx-2" v-bind="props">
                    <v-badge :model-value="userNotificationBadge" location="top right" color="error" dot>
                        <v-icon icon="icon-bell"></v-icon>
                    </v-badge>
                </v-btn>
            </template>
            <user-notification :data="userNotifications" />
        </v-menu>
        <v-menu transition="slide-y-transition" :width="250" content-class="bg-white elevation-1">
            <template v-slot:activator="{ isActive, props }">
                <div class="d-flex align-center mx-2" v-bind="props">
                    <v-avatar v-if="$auth.user.profile_picture_name" class="helpical-shadow" :image="$auth.user.profile_picture_name" size="38"></v-avatar>
                    <v-avatar v-else class="helpical-shadow" image="@/assets/img/noUser.png" size="38"></v-avatar>
                    <v-icon class="ms-1">{{ !isActive ? "expand_more" : "expand_less" }}</v-icon>
                </div>
            </template>
            <header-profile @logout="logout" />
        </v-menu>
    </v-app-bar>
    <v-main class="h-screen">
        <div class="h-100 d-flex flex-column pa-2 pa-md-4">
            <breadcrumb></breadcrumb>
            <v-fade-transition>
                <div class="h-100 overflow-y-auto pt-2">
                    <slot :key="$route.path" />
                </div>
            </v-fade-transition>
        </div>
    </v-main>
    <basic-settings ref="basicSettings"></basic-settings>
    <calendar v-if="$auth.user.employee" ref="calendar"></calendar>
    <voip-dialog ref="voipDialog" />
</template>
<script>
import settingSearchBox from "@/variables/settingSearchBox.js";
import Push from "push.js";
export default {
    data() {
        return {
            basicSettingsPercent: 0,
            userProfileImg: null,
            userNotifications: [],
            items: [
                {
                    title: "داشبورد",
                    icon: "icon-dashboard",
                    iconPath: 3,
                    children: [
                        {
                            title: 'داشبورد',
                            to: '/',
                            permission: true,
                        }
                    ]
                },
                {
                    title: "تیکت ها",
                    icon: "icon-ticket-dash",
                    iconPath: 7,
                    children: [
                        {
                            title: "تیکت جدید",
                            to: "/tickets/new",
                            permission: !this.$auth.user.expired,
                        },
                        {
                            title: "تیکت از طرف مشتری",
                            to: "/tickets/fromCustomer",
                            permission: this.$auth.user.employee && this.$system.license.features.ticket_send_behalf_customer && this.$rbac.can('send ticket behalf customers'),
                        },
                        {
                            title: "لیست تیکت ها",
                            to: "/tickets",
                            permission: true,
                        },
                    ],
                },
                {
                    icon: "icon-org",
                    iconPath: 8,
                    title: "سازمان‌",
                    children: [
                        {
                            title: "شعبه‌ها",
                            to: "/branches",
                            permission: this.$auth.user.full_admin,
                        },
                        {
                            title: "دپارتمان‌ها",
                            to: "/departments",
                            permission: this.$auth.user.full_admin,
                        },
                        {
                            title: "کاربران",
                            to: "/employees",
                            permission: this.$auth.user.full_admin || this.$auth.user.branch_admin || this.$auth.user.department_admin,
                        },
                    ],
                },
                {
                    icon: "icon-users",
                    iconPath: 4,
                    title: "مشتریان",
                    children: [
                        {
                            title: "سازمان‌ها",
                            to: "/organization",
                            permission: this.$rbac.can('manage organizations')
                        },
                        {
                            title: "کاربران",
                            to: "/customers",
                            permission: this.$rbac.can("manage customers"),
                        },
                    ],
                },
                {
                    icon: "icon-announcement",
                    iconPath: 4,
                    title: "اطلاعیه‌ها",
                    children: [
                        {
                            title: "کاربران سازمانی",
                            to: "/employeeAnnouncement",
                            permission: this.$auth.user.full_admin || this.$auth.user.branch_admin,
                        },
                        {
                            title: "مشتریان",
                            to: "/customerAnnouncement",
                            permission: this.$auth.user.full_admin || this.$auth.user.branch_admin,
                        },
                    ],
                },
                {
                    icon: "icon-knowledgebase",
                    iconPath: 2,
                    title: "پایگاه دانش",
                    children: [
                        {
                            title: "دسته‌بندي مقالات",
                            to: "/knowledgeBaseCategories",
                            permission: this.$system.systemSettings.kb_core && this.$rbac.can('manage knowledge base'),
                        },
                        {
                            title: "لیست مقالات",
                            to: "/knowledgeBaseArticles",
                            permission: this.$system.systemSettings.kb_core && this.$rbac.can('manage knowledge base'),
                        },
                        {
                            title: "مشاهده پایگاه دانش",
                            to: "/kb",
                            permission: this.$system.systemSettings.kb_core && this.$system.systemSettings.knowledge_base_status,
                            target: '_blank'
                        },
                    ],
                },
                {
                    icon: "icon-report",
                    iconPath: 2,
                    title: "گزارشات",
                    children: [
                        {
                            title: "گزارشات نموداری",
                            to: "/report",
                            permission: true,
                        },
                        {
                            title: "تاریخچه تماس ها",
                            to: "/callHistory",
                            permission: this.$auth.user.employee && this.$system.systemSettings.voip_active,
                        },
                        {
                            title: "لاگ درخواست ها",
                            to: "/log",
                            permission: this.$auth.user.full_admin && this.$system.license.features.log,
                        },
                    ],
                },
                {
                    icon: "icon-settings1",
                    iconPath: 2,
                    title: "تنظیمات",
                    children: [
                        {
                            title: "تنظیمات",
                            to: "/settings",
                            permission: Object.values(settingSearchBox()).some(x => x.items.some(y => y.permission)),
                        }
                    ]
                },
            ],
            selectedMenu: [],
            openedMenu: [],
            drawer: false,
            miniVariant: false,
            userNotificationBadge: false,
            user_id: null,
        };
    },
    methods: {
        async openBasicSettings() {
            this.$loading.start();
            this.$refs.basicSettings.checkBasicSettings((series) => {
                this.basicSettingsPercent = series;
                this.$loading.finish();
                this.$refs.basicSettings.$data.basicSettingsShow = true;
            });
        },
        newPage(item) {
            if (Object.hasOwn(item, 'target'))
                window.open(window.location.origin + '/' + item.to, '_blank').focus();
            else
                this.$router.push({ path: item.to })
        },
        clickedOnSidebar(item, route = false) {
            if (route) {
                this.items.forEach((el) => {
                    if (Object.hasOwn(el, 'panel')) el.panel = false;
                });
                if (Object.hasOwn(item, 'target'))
                    window.open(window.location.origin + '/' + item.to, '_blank').focus();
                else
                    this.$router.push({ path: item.to });
            } else {
                this.items.forEach((el) => {
                    if (Object.hasOwn(el, 'panel') && el.title !== item.title)
                        el.panel = false;
                });
                item.panel = !item.panel;
            }
        },
        toggleFullscreen() {
            if (document.fullscreenElement) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitRequestFullscreen) {
                    document.webkitRequestFullscreen();
                }
            } else {
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen();
                }
            }
        },
        async logout() {
            this.$auth.logout(true);
            this.$socket.leave('user.' + this.user_id);
        },
        pushListener() {
            this.$userNotifications().then((res) => {
                if (res && res.status == "OK")
                    this.userNotifications.unshift(...res.data);
            });
            this.$socket.channel('user.' + this.user_id).listen('noticeEvent', (data) => {
                if (data.push)
                    this.push(data);
                this.userNotifications.unshift(data);
                this.userNotificationBadge = true;
            });
        },
        configVoip() {
            if (this.$auth.user.employee && this.$system.systemSettings.voip_active)
                this.$socket.channel('user.' + this.user_id).listen('voipEvent', (data) => this.$refs.voipDialog.make(data));
        },
        push(item) {
            Push.create('Helpical', {
                body: item.content,
                timeout: 4000,
                onClick: () => {
                    let route = false;
                    if (item.link.split(',')[0] == 'ticket')
                        route = `${window.location.origin}/tickets/${item.link.split(',')[1]}`
                    else if (item.link.split(',')[0] == 'custom')
                        route = item.link.split(',')[1];
                    if (route)
                        window.open(route, '_blank');
                },
            });
        }
    },
    watch: {
        miniVariant() {
            localStorage.setItem("miniVariant", this.miniVariant ? 'mini' : 'expanded');
        },
        "$route"() {
            this.openedMenu = [this.items.filter(x => x.children.some(y => this.$route.path.startsWith(y.to))).at(-1)?.title ?? null];
            this.selectedMenu = [this.$route.path];
        }
    },
    created() {
        this.openedMenu = [this.items.filter(x => x.children.some(y => this.$route.path.startsWith(y.to))).at(-1)?.title ?? null];
        this.selectedMenu = [this.$route.path];
        if (localStorage.getItem("miniVariant") === 'mini')
            this.miniVariant = true;
        this.user_id = this.$auth.user.id;
        this.pushListener();
        this.configVoip();
    },
    mounted() {
        if (this.$auth.user.full_admin)
            this.$refs.basicSettings.checkBasicSettings((series) => {
                this.basicSettingsPercent = series
            });
    }
};
</script>
